import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const NoteDialog = ({ open, onOpenChange, title, desc, label = "Alasan / catatan (opsional)", confirm = "Konfirmasi", danger, onConfirm, children, testid = "note-dialog" }) => {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => { setBusy(true); try { await onConfirm(note); setNote(""); } finally { setBusy(false); } };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={testid}>
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        {desc && <p className="text-sm text-slate-600">{desc}</p>}
        {children}
        <label className="text-xs font-semibold text-slate-600">{label}</label>
        <textarea className="inp !h-20 py-2" value={note} onChange={(e) => setNote(e.target.value)} data-testid={`${testid}-note`} />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Batal</Button>
          <Button disabled={busy} onClick={go} className={danger ? "bg-rose-600 hover:bg-rose-700" : "bg-emerald-600 hover:bg-emerald-700"} data-testid={`${testid}-confirm`}>{confirm}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
